module.exports = __webpack_public_path__ + "static/imgVacancie5-b10e7a48fcf2c014ff102e4e39ee32fc.png";